
import { reactive, toRefs } from "vue";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons-vue";

export default {
  components: {
    CheckCircleFilled,
    CloseCircleFilled,
    ExclamationCircleFilled,
  },
  props: {
    infoObj: {},
    staffType: {},
  },
  setup() {
    const data = reactive({});
    return {
      ...toRefs(data),
    };
  },
};
